module.exports = __webpack_public_path__ + "static/img/10.4a27996.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/10.jpg
// module id = QclQ
// module chunks = 0